import {deimmutify, IAppState, reimmutify, rootReducer} from "./store";
import {ISession} from "./session";
import {environment} from "../../../environments/environment";

const persistState = require('redux-localstorage');

export {
  IAppState,
  ISession,
  rootReducer,
  reimmutify,
};

export let middleware = [];
export let enhancers = [
  persistState(
    '',
    {
      key: 'visbos-redux-store',
      serialize: store => JSON.stringify(deimmutify(store)),
      deserialize: state => reimmutify(JSON.parse(state)),
    })
];

if (!environment.production) {
  const env: any = window || this;
  if (env.devToolsExtension) {
    enhancers.push(env.devToolsExtension());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/redux-store/index.ts